<template>
  <div class="loader-alt">
    <span class="loader-alt-spinner"></span>
  </div>
</template>
<style lang="scss" scoped>
@use '../../static/style/loader.scss' as *;
</style>
